import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import API from '../../apiService.js';
import ALERT from '../component/Alert';
import { Redirect } from 'react-router-dom';

const SignupSchema = Yup.object().shape({
  //   firstName: Yup.string()
  //     .min(2, "Too Short!")
  //     .max(50, "Too Long!")
  //     .required("Required"),
  //   lastName: Yup.string()
  //     .min(2, "Too Short!")
  //     .max(50, "Too Long!")
  //     .required("Required"),
  //   email: Yup.string()
  //     .email("Invalid email")
  //     .required("Required"),
  // icd : Yup.string()
  // .required("ICD HARUS DIISI")
});
export default class Planning extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anamnese: props.patient.anamneses[0]
        ? props.patient.anamneses[0].anamnese
        : '',
      eval: props.patient.anamneses[0] ? props.patient.anamneses[0].eval : '0',
      id: props.patient.anamneses[0] ? props.patient.anamneses[0].id : '',
      nursing_anamnese: props.patient.anamneses[0]
        ? props.patient.anamneses[0].nursing_anamnese
        : '-',
      treat: props.patient.anamneses[0]
        ? props.patient.anamneses[0].treat
        : '-',
      visit_id: props.patient.anamneses[0]
        ? props.patient.anamneses[0].visit_id
        : props.patient.id,
      visit_inpatient_detail_id: props.patient.anamneses[0]
        ? props.patient.anamneses[0].visit_inpatient_detail_id
        : '0',
      examFinish: false,
      ref_continue: []
    };
  }

  componentDidMount() {
    this.getContinue();
    this.props.getData();
  }

  getContinue = async e => {
    const res = await API.get('management/continues/read/1');
    if (res.code === 200) {
      this.setState({
        ref_continue: res.data
      });
    } else {
      console.error('Cannot load data from remote source');
    }
  };
  handleTextChange = e => {
    console.log(e.target.value);
    let anamneses = [];
    this.setState({
      [e.target.name]: e.target.value
    });
    anamneses = { data: [this.state], param: 'anamneses' };
    // console.log(this.state);
    this.props.parentCallback(anamneses);
  };

  handleSubmit = e => {
    if (this.state.id > 0) {
      this.PutData();
    } else {
      this.PostData();
    }
    this.PutVisit();
  };

  PostData = async () => {
    var param = this.state;
    const res = await API.post('management/anamneses/create', param);
    // console.log(res);
    if (res.code === 200) {
      if (res.code === 200) {
        setTimeout(() => this.setState({ examFinish: true }), 1000);
        ALERT('success', 'Berhasil Menyimpan Data ');
      } else {
        ALERT('error', 'gagal menyimpan data');
      }
    }
  };

  PutData = async () => {
    var param = this.state;
    const res = await API.put('management/anamneses/update', param);
    if (res.code === 200) {
      setTimeout(() => this.setState({ examFinish: true }), 2000);
      ALERT('success', 'Berhasil Menyimpan Data ');
    } else {
      ALERT('error', 'gagal menyimpan data');
    }
  };
  PutVisit = async () => {
    let userData = JSON.parse(localStorage.getItem("userData"));
    let visit = {
      id: this.state.visit_id,
      nurse_id: userData.id,
    };
    let res = await API.put(`registration/change/visit`, { visit });
    if (res.code === 200) {
      // this.postPcare();
    }
  };
  handleChange = e => {
    // console.log(e);
    this.setState({
      startDate: e
    });
  };
  onReload = () => {
    this.props.history.push('/pelayanan');
  };
  render() {
    console.log(this.state);
    if (this.state.examFinish) {
      return <Redirect to="/pelayanan" />;
    }

    return (
      <div>
        <Formik
          enableReinitialize
          initialValues={{
            eval: '',
            treat: ''
          }}
          validationSchema={SignupSchema}
          onSubmit={values => {
            this.handleSubmit()
          }}
        >
          {({ values, errors, touched }) => (
            <Form>
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Tindakan Keperawatan
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Keluhan Pasien"
                      id="example-text-input"
                      name="treat"
                      onChange={this.handleTextChange}
                      value={this.state.treat}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="example-text-input"
                  className="col-md-5 col-form-label col-form-label-sm"
                >
                  Evaluasi Keperawatan
                </label>
                <div className="col-md-7">
                  <div className="row">
                    <textarea
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Keluhan Pasien"
                      id="example-text-input"
                      name="eval"
                      onChange={this.handleTextChange}
                      value={this.state.eval}
                    />
                  </div>
                </div>
              </div>

              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}
